import { useState, useRef, useCallback } from "react";
import Modal from "react-modal";

import invima1 from "../../img/invima/registro-planta-productora.png";
import invima2 from "../../img/invima/permiso-sanitario.png";
import invima3 from "../../img/invima/aprobacion-rotulado.png";

import suplementos1 from "../../img/invima/cert-buenas-practicas.png";
import suplementos2 from "../../img/invima/registro-sanitario-suplementos.png";
import suplementos3 from "../../img/invima/autorizacion-publicidad.png";

import aseo1 from "../../img/invima/cert-productos-aseo.png";
import aseo2 from "../../img/invima/notificacion-sanitaria-obligatoria.png";

import { scrollToContact } from "../../utils/scrollToContact";

Modal.setAppElement("#root");

const tabsData = {
  Alimentos: [
    {
      title: "Registro sanitario de alimentos",
      image: invima1,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto alimenticio o semielaborado en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "", points: [""] },
        { title: "", points: [""] },
      ],
    },
    {
      title: "Permiso o notificación sanitaria",
      image: invima2,
      description:
        "Elaboramos la solicitud acompañada de la información técnico legal necesaria para obtener la aprobación de comercialización, correspondiente de acuerdo al tipo de riesgo del producto.\nTenga en cuenta que cualquier alimento prefabricado que se venda directamente al público necesita estar registrado, tener un permiso y/o una notificación de salud según el nivel de riesgo del producto.",
      phases: [{ title: "", points: [""] }],
    },
    {
      title: "Aprobación de rotulado",
      image: invima3,
      description:
        "Brindamos asesoría técnico legal para el uso correcto del rotulado de alimentos, velando por una la información clara, simple y comprensible para que el consumidor pueda realizar una elección informada del producto.",
      phases: [
        {
          title:
            "FASE 1: Trabajamos en la obtención y cumplimiento de la siguiente información.",
          points: [
            "Declaración las nutrientes, contenido neto, rotulado nutricional, tamaño de porción y recomendación diaria de uso.",
          ],
        },
        {
          title: "FASE 2: Presentación de información.",
          points: [
            "Obtención y presentación de la información del producto con las cantidades y las unidades correspondientes a cada nutriente y sustancias declaradas, utilizando el Sistema Internacional de Unidades (S. I. U).",
            "Obtención y presentación de la información técnica y científica sobre las declaraciones de propiedades nutricionales o de salud.",
          ],
        },
      ],
    },
  ],
  "Suplementos dietarios": [
    {
      title: "Certificación de buenas prácticas de manufactura",
      image: suplementos1,
      description:
        "Brindamos asesoría técnico legal de acuerdo al marco normativo aplicable a empresas o persona naturales que cuente con las instalaciones y los equipos necesarios para realizar procesos de fabricación y/o el control de calidad de suplementos dietarios.",
      phases: [
        {
          title: "FASE 1: Diagnóstico",
          points: [
            "Evaluar las condiciones iniciales del cliente",
            "Establecer el plan de acción para la certificación",
          ],
        },
        {
          title: "FASE 2: Diseño",
          points: [
            "Elaboración de propuesta de diseño",
            "Distribución de las áreas",
          ],
        },
        {
          title: "FASE 3: Implementación",
          points: [
            "Implementación del sistema de gestión de calidad",
            "Solicitud de visita (diligenciamiento de formatos correspondientes y Guía de Inspección)",
            "Recopilación de la información técnico legal con la cual se solicita la visita por parte del Invima",
          ],
        },
        {
          title: "FASE 4: Auditoria",
          points: [
            "Auditoria para la verificación del cumplimiento de todos los requisitos técnico-legales del establecimiento fabricante",
          ],
        },
      ],
    },
    {
      title: "Registro sanitario de suplementos dietarios",
      image: suplementos2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto en el mercado colombiano con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [{ title: "", points: [""] }],
    },
    {
      title: "Autorización para publicidad de suplementos dietarios",
      image: suplementos3,
      description:
        "Se revisa todas las piezas publicitarias con las que se va a promocionar el productor, verificando el cumplimiento de la normatividad legal vigente",
      phases: [{ title: "", points: [""] }],
    },
  ],
  "Productos de aseo y limpieza": [
    {
      title:
        "Certificado de capacidad para producción de productos de aseo y limpieza",
      image: aseo1,
      description:
        "Brindamos asesoría técnico legal a empresas o persona naturales que cuente con las instalaciones y los equipos necesarios para realizar procesos de producción de productos de aseo y limpieza.",
      phases: [
        {
          title: "FASE 1: Diagnóstico",
          points: [
            "Evaluar las condiciones iniciales del cliente",
            "Establecer el plan de acción para la certificación",
          ],
        },
        {
          title: "FASE 2: Diseño",
          points: [
            "Elaboración de propuesta de diseño",
            "Distribución de las áreas",
          ],
        },
        {
          title: "FASE 3: Implementación",
          points: [
            "Implementación del sistema de gestión de calidad",
            "Solicitud de visita (diligenciamiento de formatos correspondientes y recopilación de la información técnico legal con la cual se solicita la visita por parte del Invima)",
          ],
        },
        {
          title: "FASE 4: Auditoria",
          points: [
            "Auditoria para la verificación del cumplimiento de todos los requisitos técnico-legales del establecimiento fabricante",
          ],
        },
      ],
    },
    {
      title:
        "Notificación sanitaria obligatoria de productos de aseo y limpieza",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto de aseo y limpieza en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
  ],
  Cosméticos: [
    {
      title: "Certificado de capacidad de producción de cosméticos",
      image: suplementos1,
      description:
        "Brindamos asesoría técnico legal a empresas o personas naturales que cuente con las instalaciones y los equipos necesarios para realizar procesos de producción de productos cosméticos.",
      phases: [
        {
          title: "FASE 1: Diagnóstico",
          points: [
            "Evaluar las condiciones iniciales del cliente",
            "Establecer el plan de acción para la certificación",
          ],
        },
        {
          title: "FASE 2: Diseño",
          points: [
            "Elaboración de propuesta de diseño",
            "Distribución de las áreas",
          ],
        },
        {
          title: "FASE 3: Implementación",
          points: [
            "Implementación del sistema de gestión de calidad",
            "Solicitud de visita (diligenciamiento de formatos correspondientes y Guía de Inspección)",
            "Recopilación de la información técnico legal con la cual se solicita la visita por parte del Invima",
          ],
        },
        {
          title: "FASE 4: Auditoria",
          points: [
            "Auditoria para la verificación del cumplimiento de todos los requisitos técnico-legales del establecimiento fabricante",
          ],
        },
      ],
    },
    {
      title: "Notificación sanitaria obligatoria de productos cosméticos",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto cosmético en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
  ],
  "Dispositivos médicos": [
    {
      title: "Notificación sanitaria obligatoria de productos cosméticos",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto cosmético en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
    {
      title: "Notificación sanitaria obligatoria de productos cosméticos",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto cosmético en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
    {
      title: "Notificación sanitaria obligatoria de productos cosméticos",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto cosmético en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
  ],
  Medicamentos: [
    {
      title: "Notificación sanitaria obligatoria de productos cosméticos",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto cosmético en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
    {
      title: "Notificación sanitaria obligatoria de productos cosméticos",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto cosmético en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
    {
      title: "Notificación sanitaria obligatoria de productos cosméticos",
      image: aseo2,
      description:
        "Brindamos asesoría técnico legal para el registro sanitario que se le asigna al fabricante, importador o comercializador para comercializar su producto cosmético en el mercado colombiano, con previo cumplimiento de todos los requisitos establecidos en la normatividad sanitaria vigente.",
      phases: [
        { title: "FASE 1: DIAGNÓSTICO", points: ["Revisión documental"] },
      ],
    },
  ],
};

// ─── Carousel reutilizable ─────────────────────────────────────────────────────
const MobileCarousel = ({ items, onCardClick }) => {
  const trackRef = useRef(null);
  const startX = useRef(0);
  const startScrollLeft = useRef(0);
  const isDragging = useRef(false);
  const hasDragged = useRef(false);

  const onPointerDown = useCallback((e) => {
    isDragging.current = true;
    hasDragged.current = false;
    startX.current = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
    startScrollLeft.current = trackRef.current.scrollLeft;
    trackRef.current.style.cursor = "grabbing";
    trackRef.current.setPointerCapture?.(e.pointerId);
  }, []);

  const onPointerMove = useCallback((e) => {
    if (!isDragging.current) return;
    const x = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
    const delta = startX.current - x;
    if (Math.abs(delta) > 4) hasDragged.current = true;
    trackRef.current.scrollLeft = startScrollLeft.current + delta;
  }, []);

  const onPointerUp = useCallback(() => {
    isDragging.current = false;
    if (trackRef.current) trackRef.current.style.cursor = "grab";
  }, []);

  return (
    <div
      ref={trackRef}
      className="flex gap-3 overflow-x-auto pb-3 cursor-grab select-none"
      style={{
        scrollSnapType: "x mandatory",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerLeave={onPointerUp}
    >
      {items.map((item, idx) => (
        <div
          key={idx}
          onClick={() => {
            if (!hasDragged.current) onCardClick(item);
          }}
          className="group flex-shrink-0 w-[40vw] max-w-[200px] border cursor-pointer p-2 sm:p-3 rounded-lg bg-white"
          style={{ scrollSnapAlign: "start" }}
        >
          <img
            src={item.image}
            alt={item.title}
            className="w-full object-cover grayscale hover:grayscale-0 transition duration-300"
            draggable={false}
          />
          <h4 className="font-medium font-geraldton p-2 line-clamp-3">
            {item.title}
          </h4>
        </div>
      ))}
    </div>
  );
};

// ─── Componente principal ──────────────────────────────────────────────────────
const DisenoProductos = ({ onCtaClick = () => {} }) => {
  const [activeTab, setActiveTab] = useState("Alimentos");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const openModal = useCallback((service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedService(null);
  }, []);

  return (
    <div className="group pt-8 lg:pt-10">
      <div className="lg:w-full flex justify-end">
        <h2 className="w-3/4 lg:w-full tracking-wider text-2xl normal-case lg:uppercase font-geraldton font-light lg:font-medium text-right lg:text-center mb-8 lg:mb-4 before:inline-block before:transition-all duration-500 before:w-5 before:h-5 before:mr-4 before:border before:border-primary before:group-hover:bg-accent before:rounded-full ">
          Trámites ante Invima y Diseño de productos
        </h2>
      </div>

      {/* ── TABS desktop ── */}
      <div className="hidden lg:flex flex-row justify-center gap-4 xl:gap-10 border-b border-gray-300 mb-8">
        {Object.keys(tabsData).map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`py-2 px-4 border-b-2  transition ${
              activeTab === tab
                ? "border-primary text-light bg-primary font-semibold rounded-t-sm"
                : "border-transparent text-gray-500 hover:text-black"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ── MOBILE: carrusel por sección ── */}
      <div className="flex flex-col gap-8 lg:hidden">
        {Object.keys(tabsData).map((tab) => (
          <div key={tab}>
            <h3 className="font-bold text-2xl mb-1">{tab}</h3>
            <hr className="w-full border-t border-primary mb-4" />
            <MobileCarousel items={tabsData[tab]} onCardClick={openModal} />
          </div>
        ))}
      </div>

      {/* ── DESKTOP: grid tab activo (sin cambios) ── */}
      <div className="hidden lg:grid grid-cols-4 gap-4">
        <div className="relative my-8 pr-4 border-r border-primary">
          <h4 className="font-bold text-xl">{activeTab}</h4>
        </div>
        {tabsData[activeTab].map((item, idx) => (
          <div
            key={idx}
            onClick={() => openModal(item)}
            className={`group flex flex-col justify-between relative my-8 pb-0 cursor-pointer transition ${
              idx < 2 ? "border-r border-primary" : ""
            }`}
          >
            <h4 className="font-medium font-geraldton text-lg">{item.title}</h4>
            <img
              src={item.image}
              alt={item.title}
              className="w-3/4 mt-4 grayscale hover:grayscale-0 transition duration-300"
            />
          </div>
        ))}
      </div>

      {/* ── Modal (sin cambios) ── */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Detalles del servicio"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        className="bg-light max-h-[95vh] overflow-y-scroll max-w-4xl w-full mx-4 p-8 relative shadow-lg border-b-[24px] border-accent"
      >
        {selectedService && (
          <div>
            <h2 className="text-xl md:text-2xl font-bold mb-4">
              {selectedService.title}
            </h2>
            <p className="mb-4 text-gray-600">{selectedService.description}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {selectedService.phases.map((phase, i) => (
                <div key={i}>
                  <h3 className="font-bold mb-1">{phase.title}</h3>
                  <ul className="list-disc pl-4 text-sm text-gray-700">
                    {phase.points.map((point, j) => (
                      <li key={j}>{point}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-700 hover:text-black font-bold"
            >
              &#10005;
            </button>
            <button
                onClick={() => {
                  closeModal();
                  onCtaClick();
                }}
              className="mt-8 px-2 py-1 border-2 border-primary font-geraldton"
            >
              Saber Más
            </button>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default DisenoProductos;
